//Search.ts ==============================================================
import "../Util/Prototypes";

import * as Search from "./Search";
import * as Settings from "../Settings";

export interface iLayer {
   name: string;    // Layer name.
   spec: Settings.iLayer; // Layer settings.
   fs: __esri.FeatureSet;  // Resulting featureSet array.
   IDs: number[] | string[];      // Actual total number of records (.length) downloaded. Object id's or parcel id's, etc.
   prevQuery: __esri.Query;  // Last query used on this layer.
   begRec: number;  // Paging offset index into the fs results array. (500) actually downloaded.
   endRec: number;  // Paging ending index into the fs results array. (999) actually downloaded.
   numRec: number;  // Number of records shown on left panel. (20) - Infinite scroll to display more.
   totRec: number;  // Virtual total possible records that "could" be downloaded for display.
   zoomAllMBR: __esri.Extent; // MBR of selected features in this layer only.
}
export let layers: Search.iLayer[] = []; // Array of all layers containing selected features.

export let activeLayer: string = "";      // Active layer name for printing, etc. (Clicked on layerName button in search results)

export let activeLayerIndex: number = 0;  // Index of active layer.
export let activeSearchTool: string = ""; // Active search tool of "Search", "Select on Map", "Advanced Search"
export let activePIN: string = "";        // Last selected parcel id.
export let mode: string = "New";          // Selection mode - "New", "Add", "Remove"
export let grandTotRec: number = 0;       // Virtual grand total records for all layers.
export let extentAfterSearch: __esri.Extent;        // The last extent after a search or select for use in print tool.

//Setters.
export function setLayers(layerArray: Search.iLayer[]) {
   layers = layerArray;
}
export function setActiveLayerName(name: string) {
   activeLayer = name;
}
export function setActiveSearchTool(searchToolName: string) {
   activeSearchTool = searchToolName;
}
export function setActivePIN(pin: string) {
   activePIN = pin;
}
export function setMode(selectMode: string) {
   mode = selectMode;
}
export function setGrandTotRec(grandTotal: number) {
   grandTotRec = grandTotal;
}
export function setExtentAfterSearch(extent: __esri.Extent) {
   extentAfterSearch = extent;
}
export function setActiveLayerIndex(i: number) {
   activeLayerIndex = i;
}

//Get total number of selected records for the active layer.
export function getActiveLayerNumRec(): number {
   const i: number = Search.activeLayerIndex;
   if (Search.layers[i]) {
      return Search.layers[i].totRec;
   }
   return 0;
}
